export function getPathwayTitle(item) {
  const lines = String(item?.item_title || '').split(/\r?\n/).map(line => line.trim()).filter(Boolean);
  const details = lines.slice(1).join(' ');
  const match = details.match(/^(.*?)\s*(?:-\s*)?#(\d+)\s*(?:-\s*)?(.*)$/);
  return {
    speech: lines[0] || '',
    pathway: match ? match[1].trim() : details,
    project: match ? `#${match[2]}${match[3].trim() ? ` - ${match[3].trim()}` : ''}` : '',
  };
}
